import { passwordSchema } from '@barbeiropro/contracts';

const LOWER = 'abcdefghijkmnopqrstuvwxyz';
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const DIGITS = '23456789';
const SYMBOLS = '!@#$%&*?-_+=';

/** Inteiro uniforme em [0, max) a partir de crypto.getRandomValues (rejeição, sem viés de módulo). */
function randomInt(max: number): number {
  const limit = Math.floor(0x1_0000_0000 / max) * max;
  const buf = new Uint32Array(1);
  do crypto.getRandomValues(buf);
  while (buf[0]! >= limit);
  return buf[0]! % max;
}

/** Senha forte (padrão 20 caracteres, mínimo 16) com minúscula, maiúscula, número e símbolo; atende a política do cadastro. */
export function generateStrongPassword(length = 20): string {
  const size = Math.max(16, length);
  const all = LOWER + UPPER + DIGITS + SYMBOLS;
  const chars = [LOWER, UPPER, DIGITS, SYMBOLS].map((set) => set[randomInt(set.length)]!);
  while (chars.length < size) chars.push(all[randomInt(all.length)]!);
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randomInt(i + 1);
    [chars[i], chars[j]] = [chars[j]!, chars[i]!];
  }
  return chars.join('');
}

export interface PasswordCheck {
  /** requisitos da política (iguais ao backend) */
  rules: { label: string; ok: boolean }[];
  valid: boolean;
  /** 0 a 4 */
  score: number;
  label: string;
}

const LABELS = ['Muito fraca', 'Fraca', 'Razoável', 'Boa', 'Forte'];

export function checkPassword(pw: string): PasswordCheck {
  const rules = [
    { label: 'Mínimo de 8 caracteres', ok: pw.length >= 8 },
    { label: 'Ao menos uma letra', ok: /[A-Za-z]/.test(pw) },
    { label: 'Ao menos um número', ok: /\d/.test(pw) },
  ];
  const valid = passwordSchema.safeParse(pw).success;
  let score = 0;
  if (valid) {
    score = 1;
    if (pw.length >= 12) score++;
    if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score++;
    if (/[^A-Za-z0-9]/.test(pw) && pw.length >= 14) score++;
  }
  return { rules, valid, score, label: pw ? LABELS[score]! : '' };
}
